export const attrsToHuman = {
  nicknema: "apelido",
  email: "e-mail",
  password: "senha",
  password_confirmation: "confirmação de senha",
  mkt: "permissão de ofertas e serviços",
  integration: "",
  voucher: "",
  holder_name: "nome impresso no cartão",
  card_expiration: "data de expiração",
  card_number: "números do cartão",
  card_cvv: "código de Segurança",
  payment_company_code: "",
  card_number_first_six: "seis primeiros digitos",
  card_number_last_four: "quatro ultimos digitos",
  payment_company_id: "bandeira"
};

export const formatter = response => {
  if (typeof response !== "object") return null;

  let messages = [];
  Object.keys(response).map(i => {
    messages = messages.concat(
      response[i].map(msg => {
        if (i === "integration") return msg;
        return `O campo ${attrsToHuman[i] || i} ${msg}`;
      })
    );
  });

  return messages;
};



// WEBPACK FOOTER //
// ./src/services/apiResponseFormatter.js